import ActionTypes from '@constants/action_types.js'

export function receiveTags(tags) {
  return {
    type: ActionTypes.RECEIVE_TAGS,
    payload: tags,
  }
}
